import Request from "../../../services/request";

/**
 * Правила соответствия узлов — связь с бэкендом (m_to_m_scheme_node_rules).
 *
 * Схема узла приходит с /dictionary/scheme-node-rules/scheme/{id} уже
 * разложенной по 4 сторонам с учётом зеркала; элемент:
 *   { id, id_node, side, operand, mirrored }
 * Операнд сейчас всегда 'compatible' (остальные заморожены на бэке).
 */

const API = "/dictionary/scheme-node-rules";
export const SIDES = ["top", "left", "bottom", "right"];
export const DEFAULT_OPERAND = "compatible";

function emptySides() {
  return { top: [], left: [], bottom: [], right: [] };
}

export default {
  namespaced: true,
  state: {
    centralNodeId: null,
    activeSide: "left",
    sides: emptySides(),
    loading: false,
  },
  getters: {
    currentSides(state) {
      return state.sides;
    },
    // узлы, занятые на конкретной стороне (ограничение per-side: узел можно
    // ставить на несколько сторон, но не дважды на одну)
    usedNodeIdsBySide: (state) => (side) => {
      const ids = new Set();
      (state.sides[side] || []).forEach((c) => ids.add(c.id_node));
      return ids;
    },
  },
  mutations: {
    setCentralNode(state, id) {
      state.centralNodeId = id || null;
    },
    setActiveSide(state, side) {
      if (SIDES.includes(side)) state.activeSide = side;
    },
    setSides(state, payload) {
      const src = payload && typeof payload === "object" ? payload : {};
      state.sides = {
        top: Array.isArray(src.top) ? src.top : [],
        left: Array.isArray(src.left) ? src.left : [],
        bottom: Array.isArray(src.bottom) ? src.bottom : [],
        right: Array.isArray(src.right) ? src.right : [],
      };
    },
    clearSides(state) {
      state.sides = emptySides();
    },
    changeLoading(state, value) {
      state.loading = value;
    },
  },
  actions: {
    async selectCentralNode({ commit, dispatch }, id) {
      commit("setCentralNode", id || null);
      commit("clearSides");
      if (id) await dispatch("fetchScheme");
    },
    async fetchScheme({ state, commit }) {
      if (!state.centralNodeId) return;
      commit("changeLoading", true);
      try {
        const response = await Request.get(
          this.state.BASE_URL + `${API}/scheme/${state.centralNodeId}`
        );
        if (response && !response.isError) commit("setSides", response.data);
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoading", false);
      }
    },
    async addNodeToSide({ state, commit, dispatch }, { side, id_node }) {
      if (!state.centralNodeId) return;
      commit("changeLoading", true);
      try {
        const response = await Request.post(this.state.BASE_URL + API, {
          id_node_a: state.centralNodeId,
          id_node_b: id_node,
          side: side || state.activeSide,
          operand: DEFAULT_OPERAND,
        });
        await dispatch("fetchScheme");
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoading", false);
      }
    },
    async removeConnector({ commit, dispatch }, { id }) {
      commit("changeLoading", true);
      try {
        const response = await Request.delete(
          this.state.BASE_URL + `${API}/${id}`
        );
        await dispatch("fetchScheme");
        return response;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      } finally {
        commit("changeLoading", false);
      }
    },
  },
};
